import qs from 'querystring'
import {MessageBox, Message} from 'element-ui'
import CryptoJS from 'crypto-js';
import {
  setAES,
  decryptAES,
  sortParams
} from './index.js';
/**
 * Created by yqr on 2018/4/13.
 */
import Env from '../src/api/env'
import axios from 'axios'
import router from '../src/router'


axios.defaults.withCredentials = false
axios.defaults.baseURL = Env.baseURL

const service = axios.create({
  timeout: 30000, // request timeout
  transformRequest: [(data) => {
    return qs.stringify(data)
  }]
})
// request interceptor
service.interceptors.request.use(
  config => {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    config.headers['x-token'] = window.localStorage.getItem('xcToken') || ''
    const paramObj = config.params
    const paramData = config.data
    if(!config.isCheck){
      var obj = {
        'x-check': 1,
        'x-ts': Date.now(),
        'x-body': setAES(JSON.stringify(paramObj)),
      }
      var obj2 = obj
      obj2['x-sign'] = CryptoJS.MD5(sortParams(obj)).toString()
      config.params = obj2
    }
    if(paramData&&!config.isCheck){
      var obj3 = {
        'x-check': 1,
        'x-ts': Date.now(),
        'x-body': setAES(JSON.stringify(paramData)),
      }
      var obj4 = obj3
      obj4['x-sign'] = CryptoJS.MD5(sortParams(obj3)).toString()
      config.data = obj4
    }
    // console.log('config',config)
    return config
  },
  error => {
    // do something with request error
    return Promise.reject(error)
  }
)
// 基地址
const base = Env.baseURL

// //测试使用
// export const ISDEV = Env.isDev;

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code == 100) {
      window.localStorage.removeItem('xcToken')
      if (window.location.hash) {
        const url = window.location.hash.split('#')[1]
        router.replace({
          path: '/login',
          query: {
            redirectUrl: url
          }
        })
      }
    } else if (res.code == 1) {
      Message.error(res.msg)
    } else {
      if (res.data && res.data.encrypt) {
        var obj = {}
        obj.data = JSON.parse(decryptAES(res.data.encrypt))
        return obj
      } else {
        return res
      }
      // return res
    }
  },
  error => {
    return Promise.reject(error)
  }
)

export default service



//////////////////
// WEBPACK FOOTER
// ./utils/request.js
// module id = null
// module chunks = 